import dayjs from "dayjs";
import DateRangePicker from "react-bootstrap-daterangepicker";
import MultiButton from "./MultiButton";
import { IconCalendarEvent, IconChevronDown } from "@tabler/icons-react";
import { attachDateRangeCustomActiveFix } from "./dateRangePickerFix";

const datePickerLocale = {
  format: "DD/MM/YYYY",
  separator: " - ",
  applyLabel: "Apply",
  cancelLabel: "Cancel",
  customRangeLabel: "Custom Range",
  daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  monthNames: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  firstDay: 0,
};

const getDateRanges = () => ({
  "All Time": [new Date("1970-01-01"), dayjs().toDate()],
  Today: [dayjs().toDate(), dayjs().toDate()],
  Yesterday: [
    dayjs().subtract(1, "days").toDate(),
    dayjs().subtract(1, "days").toDate(),
  ],
  "Last 7 Days": [dayjs().subtract(6, "days").toDate(), dayjs().toDate()],
  "Last 30 Days": [dayjs().subtract(29, "days").toDate(), dayjs().toDate()],
  "This Month": [
    dayjs().startOf("month").toDate(),
    dayjs().endOf("month").toDate(),
  ],
  "Last Month": [
    dayjs().subtract(1, "month").startOf("month").toDate(),
    dayjs().subtract(1, "month").endOf("month").toDate(),
  ],
});

const Title = (props) => {
  const {
    newClass,
    name,
    dayAnalyticsShow,
    titleShow,
    setStartDate,
    setEndDate,
    endDate,
    startDate,
    setMultiButtonSelect,
    multiButtonSelect,
    labelData,
  } = props;

  const handleApply = (event, picker) => {
    const start = dayjs(picker.startDate).format("YYYY-MM-DD");
    const end = dayjs(picker.endDate).format("YYYY-MM-DD");
    // Keep API contract: All Time continues to send "All"
    if (start === "1970-01-01") {
      setStartDate("All");
      setEndDate("All");
      return;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const { color, bgColor } = props;

  const startAllDate = "1970-01-01";
  const endAllDate = dayjs().format("YYYY-MM-DD");

  const isAllSelected =
    (startDate === startAllDate && endDate === endAllDate) ||
    (startDate === "All" && endDate === "All") ||
    (startDate === "ALL" && endDate === "ALL");

  const dateRangeLabel =
    !isAllSelected &&
    startDate &&
    endDate &&
    dayjs(startDate).isValid() &&
    dayjs(endDate).isValid()
      ? `${dayjs(startDate).format("DD MMM YYYY")} - ${dayjs(endDate).format(
          "DD MMM YYYY"
        )}`
      : "Select Date Range";

  return (
    <>
      <div>
        <div className="row align-items-center">
          <div
            className={` ${
              dayAnalyticsShow
                ? `col-12 col-sm-12 col-md-6 ${
                    titleShow ? "col-lg-6" : "col-lg-8"
                  }`
                : "col-12"
            }`}
          >
            {titleShow && (
              <div className={!newClass ? `boxBetween ` : `${newClass}`}>
                <div className="title">
                  <h4
                    className="mb-0  text-capitalize text-nowrap"
                    style={{ fontSize: "20px", fontWeight: "500" }}
                  >
                    {name}
                  </h4>
                </div>
              </div>
            )}
            <div className="multi-user-btn ">
              <MultiButton
                multiButtonSelect={multiButtonSelect ? multiButtonSelect : ""}
                setMultiButtonSelect={
                  setMultiButtonSelect ? setMultiButtonSelect : ""
                }
                label={labelData ? labelData : []}
              />
            </div>
          </div>
          {dayAnalyticsShow ? (
            <div
              className={`col-12 col-sm-12 col-md-6 col-lg-4 pl-0 ${
                titleShow ? "col-lg-6" : "col-lg-4"
              }`}
              style={{ paddingRight: "10px", paddingLeft: "0px" }}
            >
              <div className="dayAnalytics">
                <div className="date-range-box">
                  <DateRangePicker
                    initialSettings={{
                      startDate: undefined,
                      endDate: undefined,
                      alwaysShowCalendars: true,
                      showDropdowns: false,
                      autoUpdateInput: false,
                      opens: "left",
                      locale: datePickerLocale,
                      ranges: getDateRanges(),
                      maxDate: new Date(),
                    }}
                    onShow={attachDateRangeCustomActiveFix}
                    onApply={handleApply}
                  >
                    <button
                      type="button"
                      className={`date-range-trigger date-range-style ${
                        bgColor || ""
                      } ${color || ""}`}
                      aria-label="Select date range"
                    >
                      <IconCalendarEvent
                        className="date-range-trigger__icon"
                        size={18}
                        stroke={2}
                      />
                      <span className="date-range-trigger__label">
                        {dateRangeLabel}
                      </span>
                      <IconChevronDown
                        className="date-range-trigger__chevron"
                        size={18}
                        stroke={2}
                      />
                    </button>
                  </DateRangePicker>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Title;
